<template>
  <div class="overlay-wrapper">
    <div class="table-title">
      <p v-if="mode !== 'edit'">{{$t('dash.sources.add.new')}}</p>
      <p v-else>{{$t('dash.sources.edit')}}</p>
      <br>
    </div>

    <div class="type box post-content source-type">
        <div class="display-wrapper">
            <div class="thumbnail">
                <input
                        name="radio-sources"
                        type="radio"
                        value="rss"
                        v-model="form.type"
                        @click="changeType('rss')"
                />
                <div class="thumbnail-wrapper">
                    <div class="thumbnail-content">
                        <div class="vertical-align">
                            <div class="thumbnail-img-wrapper">
                                <img
                                        src="../../../assets/img/rss-source.svg"
                                        alt="rss"
                                />
                            </div>
                            <div class="thumbnail-name">
                                <p>{{ $t('dash.sources.rss-source') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="thumbnail">
                <input
                        name="radio-sources"
                        type="radio"
                        value="google-news"
                        v-model="form.type"
                        @click="changeType('google-news')"
                />
                <div class="thumbnail-wrapper">
                    <div class="thumbnail-content">
                        <div class="vertical-align">
                            <div class="thumbnail-img-wrapper">
                                <img
                                        src="../../../assets/img/google-news-source.svg"
                                        alt="google-news"
                                />
                            </div>
                            <div class="thumbnail-name">
                                <p>{{ $t('dash.sources.google-news-source') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="thumbnail">
                <input
                        name="radio-sources"
                        type="radio"
                        value="youtube"
                        v-model="form.type"
                        @click="changeType('youtube')"
                />
                <div class="thumbnail-wrapper">
                    <div class="thumbnail-content">
                        <div class="vertical-align">
                            <div class="thumbnail-img-wrapper">
                                <!-- <img
                                        src="../../../assets/img/youtube-source.svg"
                                        alt="youtube-source"
                                /> -->
                                <img
                                        src="../../../assets/img/logo-youtube.svg"
                                        alt="youtube-source"
                                />
                            </div>
                            <div class="thumbnail-name">
                                <p>{{ $t('dash.sources.youtube-source') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="thumbnail">
                <input
                        name="radio-sources"
                        type="radio"
                        value="vimeo"
                        v-model="form.type"
                        @click="changeType('vimeo')"
                />
                <div class="thumbnail-wrapper">
                    <div class="thumbnail-content">
                        <div class="vertical-align">
                            <div class="thumbnail-img-wrapper">
                                <img
                                        src="../../../assets/img/vimeo-source.svg"
                                        alt="vimeo-source"
                                />
                            </div>
                            <div class="thumbnail-name">
                                <p>{{ $t('dash.sources.vimeo-source') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="thumbnail">
                <input
                        name="radio-sources"
                        type="radio"
                        value="dailymotion"
                        v-model="form.type"
                        @click="changeType('dailymotion')"
                />
                <div class="thumbnail-wrapper">
                    <div class="thumbnail-content">
                        <div class="vertical-align">
                            <div class="thumbnail-img-wrapper">
                                <img
                                        src="../../../assets/img/dailymotion-source.svg"
                                        alt="dailymotion-source"
                                />
                            </div>
                            <div class="thumbnail-name">
                                <p>{{ $t('dash.sources.dailymotion-source') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="thumbnail">
                <input
                        name="radio-sources"
                        type="radio"
                        value="pinterest"
                        v-model="form.type"
                        @click="changeType('pinterest')"
                />
                <div class="thumbnail-wrapper">
                    <div class="thumbnail-content">
                        <div class="vertical-align">
                            <div class="thumbnail-img-wrapper">
                                <img
                                        src="../../../assets/img/pinterest-source.svg"
                                        alt="pinterest-source"
                                />
                            </div>
                            <div class="thumbnail-name">
                                <p>{{ $t('dash.sources.pinterest-source') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="thumbnail">
                <input
                        name="radio-sources"
                        type="radio"
                        value="twitter"
                        v-model="form.type"
                        @click="changeType('twitter')"
                        :disabled="true"
                />
                <div class="thumbnail-wrapper">
                    <div class="thumbnail-content">
                        <div class="vertical-align">
                            <div class="thumbnail-img-wrapper">
                                <img
                                        src="../../../assets/img/twitter-source.svg"
                                        alt="twitter-source"
                                />
                            </div>
                            <div class="thumbnail-name">
                                <p>{{ $t('dash.sources.twitter-source') }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="form-wrapper">
      <div class="form">
        <form @submit.prevent="validate('form')" data-vv-scope="form">
          <div class="input-wrapper">
            <vs-input
              vs-label="Name"
              v-validate="'required'"
              :class="{'input': true,
              'is-danger': errors.has('form.name') }"
              vs-size="large"
              type="text"
              name="name"
              class="inputx"
              :placeholder="form.name && form.name != '' ? '' : $t('dash.sources.name_placeholder')"
              v-model="form.name"
              data-qa="form-source-name"
              v-on:keyup="manualName=true"
            />
            <i v-show="errors.has('form.name')" class="fa fa-warning"></i>
            <span
              v-show="errors.has('form.name')"
              class="help is-danger"
            >{{ errors.first('form.name') }}</span>
          </div>
          <div class="input-wrapper" v-if="!form.type || form.type == 'rss'">
            <vs-input
              vs-label="Url flux RSS"
              v-validate="'required'"
              :class="{'input': true,
            'is-danger': errors.has('form.url') }"
              vs-size="large"
              type="text"
              name="url"
              class="inputx lower-input"
              :placeholder="form.url && form.url != '' ? '' : $t('dash.sources.url_placeholder')"
              v-model="form.url"
              data-qa="form-source-url"
            />
            <i v-show="errors.has('form.url')" class="fa fa-warning"></i>
            <span
              v-show="errors.has('form.url')"
              class="help is-danger"
            >{{ errors.first('form.url') }}</span>
          </div>


          <div class="input-wrapper" v-else>
            <div class="type box post-content source-type" v-if="form.type == 'dailymotion'">
                <div class="display-wrapper">
                    <div class="thumbnail">
                        <input
                                name="radio-sources"
                                type="radio"
                                value="search"
                                v-model="searchType"
                        />
                        <div class="thumbnail-wrapper">
                            <div class="thumbnail-content">
                                <div class="vertical-align">
                                    <div class="thumbnail-img-wrapper">
                                        <img
                                                src="../../../assets/img/source-search_type-search.svg"
                                                alt="search"
                                        />
                                    </div>
                                    <div class="thumbnail-name">
                                        <p>{{ $t('dash.sources.search') }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="thumbnail">
                        <input
                                name="radio-sources"
                                type="radio"
                                value="tag"
                                v-model="searchType"
                        />
                        <div class="thumbnail-wrapper">
                            <div class="thumbnail-content">
                                <div class="vertical-align">
                                    <div class="thumbnail-img-wrapper">
                                        <img
                                                src="../../../assets/img/source-search_type-tag.svg"
                                                alt="tag"
                                        />
                                    </div>
                                    <div class="thumbnail-name">
                                        <p>{{ $t('dash.sources.tag') }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="thumbnail">
                        <input
                                name="radio-sources"
                                type="radio"
                                value="user"
                                v-model="searchType"
                        />
                        <div class="thumbnail-wrapper">
                            <div class="thumbnail-content">
                                <div class="vertical-align">
                                    <div class="thumbnail-img-wrapper">
                                        <img
                                                src="../../../assets/img/source-search_type-user.svg"
                                                alt="user"
                                        />
                                    </div>
                                    <div class="thumbnail-name">
                                        <p>{{ $t('dash.sources.user') }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <select v-model="form.language" v-if="form.type == 'google-news'" class="lang">
              <option v-for="(lang, key) in languages"
                :key="key"
                :value="lang"
              >{{ $t(`dash.languages.${lang.name}`) }}</option>
            </select>

            <vs-input
              vs-label="Url flux RSS"
              v-validate="'required'"
              :class="{'input': true,
            'is-danger': errors.has('form.custom_field') }"
              vs-size="large"
              type="text"
              name="custom_field"
              class="inputx lower-input"
              :placeholder="form.custom_field && form.custom_field != '' ? '' : $t(`dash.sources.custom_field_placeholder-${form.type}`)"
              v-model="form.custom_field"
              data-qa="form-source-custom_field"
            />
            <i v-show="errors.has('form.custom_field')" class="fa fa-warning"></i>
            <span
              v-show="errors.has('form.custom_field')"
              class="help is-danger"
            >{{ errors.first('form.custom_field') }}</span>
          </div>
          <!-- <div class="input-wrapper">
            <vs-input
              vs-label="Url Logo"
              :class="{'input': true,
            'is-danger': errors.has('form.logo') }"
              vs-size="large"
              type="text"
              name="logo"
              class="inputx"
              :placeholder="form.logo && form.logo != '' ? '' : $t('dash.sources.logo_placeholder')"
              v-model="form.logo"
            />
            <i v-show="errors.has('form.logo')" class="fa fa-warning"></i>
            <span
              v-show="errors.has('form.logo')"
              class="help is-danger"
            >{{ errors.first('form.logo') }}</span>
          </div> -->
          <div class="input-wrapper">
            <vs-checkbox v-model="form.evergreen">{{ $t('dash.sources.evergreen_placeholder') }}</vs-checkbox>
          </div>
          <!--div class="row">
            <div class="input-wrapper">
              <vs-input
                vs-label="Topic"
                v-validate="'required'"
                :class="{'input': true,
              'is-danger': errors.has('form.topic') }"
                vs-size="large"
                color="#B20564"
                type="text"
                name="topic"
                class="inputx"
                v-bind:placeholder="'Football'"
                v-model="form.topic"
              />
              <i v-show="errors.has('form.topic')" class="fa fa-warning"></i>
              <span
                v-show="errors.has('form.topic')"
                class="help is-danger"
              >{{ errors.first('form.topic') }}</span>
            </div>
            <div class="input-wrapper">
              <vs-input
                vs-label="Category"
                v-validate="'required'"
                :class="{'input': true,
              'is-danger': errors.has('form.category') }"
                vs-size="large"
                color="#B20564"
                type="text"
                name="category"
                class="inputx"
                v-bind:placeholder="'PSG'"
                v-model="form.category"
              />
              <i v-show="errors.has('form.category')" class="fa fa-warning"></i>
              <span
                v-show="errors.has('form.category')"
                class="help is-danger"
              >{{ errors.first('form.category') }}</span>
            </div>
          </div-->
        </form>
      </div>
    </div>

    <vs-button
      v-if="mode!=='edit'"
      class="btn-img sources-btn"
      color="#2F1937"
      size="large"
      @click="submit"
      vs-type="filled"
      data-qa="form-source-submit"
    >
      <p>{{$t('dash.sources.submit')}}</p>
      <img class="icon-white" src="../../../assets/img/icon_launch.svg" alt="posted">
    </vs-button>
    <vs-button
      v-else
      class="btn-img sources-btn"
      color="#2F1937"
      size="large"
      @click.prevent="update"
      vs-type="filled"
      data-qa="form-source-submit"
    >
      <p>{{$t('dash.sources.save')}}</p>
    </vs-button>

    <div class="close-btn" @click="cancel">
      <i class="material-icons">close</i>
    </div>
  </div>
</template>

<script>
import Sources from '../../mixins/Sources'
import Posts from '../../mixins/Posts'
import Notif from '../../mixins/Notif'

export default {
  name: 'component-sources-overlay',

  mixins: [Sources, Posts, Notif],

  props: {
    editSource: String,
    mode: String
  },

  data() {
    return {
      form: {
        name: null,
        url: null,
        analytics: null,
        logo: null,
        topic: null,
        category: null,
        evergreen: true,
        type: 'rss',
        custom_field: null,
        language: {name: 'france', country: 'FR', lang: 'fr'}
      },
      searchType: 'search',
      sourceList: [],
      manualName: false,
      languages: [
        {name: 'france', country: 'FR', lang: 'fr'},
        {name: 'us', country: 'US', lang: 'en'},
        {name: 'uk', country: 'GB', lang: 'en'},
        {name: 'italy', country: 'IT', lang: 'it'},
        {name: 'spain', country: 'ES', lang: 'es'},
        {name: 'portugal', country: 'PT', lang: 'pt'},
        {name: 'germany', country: 'DE', lang: 'de'},
      ]
    }
  },

  mounted() {
    this.sourceList = localStorage.sources ? JSON.parse(localStorage.sources) : []
    this.addDefaultSourceName(this.form.type)
    this.form.language = this.languages.find(l => l.lang == this.$i18n.locale) || {name: 'france', country: 'FR', lang: 'fr'}
  },

  watch: {
    editSource(){
      this.sourceList = localStorage.sources ? JSON.parse(localStorage.sources) : []
      if(this.editSource != '' && this.mode == 'edit'){
        let idEditSource = this.editSource
        let source = this.sourceList.find(function(element) {
          return element.id === idEditSource
        })

        this.form.name = source.name
        this.form.url = source.url
        this.form.analytics = source.analytics
        this.form.logo = source.logo
        this.form.topic = source.topic
        this.form.category = source.category
        this.form.evergreen = source.evergreen || false
        this.form.type = source.type || 'rss'
        this.form.custom_field = source.custom_field || null

        this.manualName = false

        if(source.type == 'dailymotion')
          this.searchType = source.url.includes('search') 
                                ? 'search'
                                : (source.url.includes('tag') ? 'tag' : 'user')

        if(source.type == 'google-news') {
          console.log(source.url, this.languages.find(l => source.url.includes(`ceid=${l.country}:${l.lang}`)))
          this.form.language = this.languages.find(l => source.url.includes(`ceid=${l.country}:${l.lang}`))
        }
      }
    },

    mode(){
      this.sourceList = localStorage.sources ? JSON.parse(localStorage.sources) : []
      if(this.editSource != '' && this.mode == 'edit'){
        let idEditSource = this.editSource
        let source = this.sourceList.find(function(element) {
          return element.id === idEditSource
        })

        this.form.name = source.name
        this.form.url = source.url
        this.form.analytics = source.analytics
        this.form.logo = source.logo
        this.form.topic = source.topic
        this.form.category = source.category
        this.form.evergreen = source.evergreen || false
        this.form.type = source.type || 'rss'
        this.form.custom_field = source.custom_field || null
        if(source.type == 'dailymotion')
          this.searchType = source.url.includes('search') 
                                ? 'search'
                                : (source.url.includes('tag') ? 'tag' : 'user')
        
        this.manualName = true
      }
      else {
        this.form.name = null
        this.form.url = null
        this.form.analytics = null
        this.form.logo = null
        this.form.topic = null
        this.form.category = null
        this.form.evergreen = true
        this.form.type = 'rss'
        this.form.custom_field = null
        this.searchType = 'search'
        
        this.manualName = false
        this.addDefaultSourceName(this.form.type)
      }
    }
  },

  methods: {

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    changeType(type) {
      this.form.type = type
      this.addDefaultSourceName(type)
    },

    addDefaultSourceName(type){
      if(!this.manualName && this.mode != 'edit') {
        let typeName = 'RSS'
        if(type == 'google-news') typeName = 'News'
        else if(type == 'rss') typeName = 'RSS'
        else if(type) typeName = this.capitalizeFirstLetter(type)
        this.form.name = `${typeName} ${this.sourceList.filter(s => s.type == type).length + 1}`
      }
    },

    /*
     * Check form validation
     */
    validate(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (!result && this.$validator.errors.items.length) return
        this.submit()
      })
    },

    async constructUrlFeed(){
      if(this.form.type != 'rss' && this.form.custom_field.trim() == "")
        return ''

      switch(this.form.type) {
        case 'rss':
          return this.form.url
        case 'google-news':
          return `https://news.google.com/rss/search?&hl=${this.form.language.lang}&gl=${this.form.language.country}&scoring=n&num=50&q=${encodeURI(this.form.custom_field)}&ceid=${this.form.language.country}:${this.form.language.lang}`
        case 'youtube':
          if(this.form.custom_field.includes('https://www.youtube.com/channel/')){
            let channel_id = this.form.custom_field.replace('https://www.youtube.com/channel/', '').split('/')[0]
            return `https://www.youtube.com/feeds/videos.xml?channel_id=${channel_id}`
          }
          else if(this.form.custom_field.includes('https://www.youtube.com/user/')){
            let user = this.form.custom_field.replace('https://www.youtube.com/user/', '').split('/')[0]
            return `https://www.youtube.com/feeds/videos.xml?user=${user}`
          }
          else {
            let metas = await this.getNewsMeta(this.form.custom_field)
            if(metas && metas.body && metas.body.meta && metas.body.meta.og && metas.body.meta.og.url){
              let channel_id = metas.body.meta.og.url.replace('https://www.youtube.com/channel/', '').split('/')[0]
              return `https://www.youtube.com/feeds/videos.xml?channel_id=${channel_id}` 
            }
          }
          break
        case 'vimeo':
          return `${this.form.custom_field}/videos/rss`
        // eslint-disable-next-line
        case 'dailymotion': 
          let dailymotionFeed = this.searchType == 'search' 
                                        ? 'https://www.dailymotion.com/rss/search/'
                                        : (this.searchType == 'tag'
                                                      ? 'https://www.dailymotion.com/rss/fr/tag/'
                                                      : 'https://www.dailymotion.com/rss/user/')
          let search = ['search', 'tag'].includes(this.searchType) 
                                ? this.form.custom_field
                                : new URL(this.form.custom_field).pathname.replace('/', '')
                                                
          return dailymotionFeed + encodeURI(search)
        // eslint-disable-next-line  
        case 'pinterest':
          let pinterestFeed = new URL(this.form.custom_field)
          return pinterestFeed.pathname.split('/')[2].includes('_')
                              ? `${pinterestFeed.origin}/${pinterestFeed.pathname.split('/')[1]}/feed.rss`
                              : `${this.form.custom_field.substr(-1) == '/' ? this.form.custom_field.substr(0, this.form.custom_field.length-1) : this.form.custom_field}.rss`
        case 'twitter':
          break
      }
    },

    /*
     * Create new source
     */
    async submit() {
      if(this.sourceList && this.sourceList.filter(source => source.url == this.form.url) > 0){
        this.notify({
          time: 10000,
          title: this.$t('dash.notifications.error_title'),
          text: this.$t('dash.notifications.source_already_exist'),
          color: 'primary',
          id: 'norepeat'
        })
      }
      else {
        let url = await this.constructUrlFeed()

        if(this.form.name.trim() == "" || url.trim() == "")
          return this.notify({
              time: 10000,
              title: this.$t('dash.notifications.error_title'),
              text: this.$t('dash.notifications.error.meta-og'),
              color: 'primary',
              id: 'norepeat'
            })

        let body = {
          name: this.form.name,
          url: url,
          evergreen: this.form.evergreen,
          type: this.form.type,
          custom_field: this.form.custom_field
        }
  
        this.$ga.event('sources', 'create')
        this.$vs.loading({color : 'primary'})
  
        this.newSource(body).then(res => {
          this.$vs.loading.close()
          const { success } = res.body
  
          if (!success || success !== true) {
            return this.notify({
              time: 10000,
              title: this.$t('dash.notifications.error_title'),
              text: `${this.$t('dash.notifications.source_parsing_error')} ${res.body[0]}` || this.$t(res.body.error),
              color: 'primary',
              id: 'norepeat'
            }, {
              component: "SourcesOverlay",
              action: "newSource",
              params: {
                ...body
              }
            })
          }
  
          this.$emit('fetchSources')
          this.cleanData()
  
          this.notify({
            time: 10000,
            title: this.$t('dash.notifications.success_title'),
            text: this.$t('dash.notifications.source_created'),
            color: 'primary',
            id: 'norepeat'
          })
        })
      }
    },

    async update() {
      let url = await this.constructUrlFeed()

      if(this.form.name.trim() == "" || url.trim() == "")
        return this.notify({
            time: 10000,
            title: this.$t('dash.notifications.error_title'),
            text: this.$t('dash.notifications.error.meta-og'),
            color: 'primary',
            id: 'norepeat'
          })

      let body = {
        id: this.editSource,
        name: this.form.name,
        url: url, 
        evergreen: this.form.evergreen,
        type: this.form.type,
        custom_field: this.form.custom_field
        /*"uid" : this.form.analytics,
        "logo" : this.form.logo,
        "topic" : this.form.topic,
        "category" : this.form.category*/
      }

      this.$vs.loading({color : 'primary'})
      this.putSource(body).then(res => {
        this.$vs.loading.close()
        const { success, source } = res.body

        if (!success || success !== true) {
          return this.notify({
            time: 10000,
            title: this.$t('dash.notifications.error_title'),
            text: `${this.$t('dash.notifications.source_parsing_error')} ${res.body[0]}` || this.$t(res.body.error),
            color: 'primary',
            id: 'norepeat'
          }, {
            component: "SourcesOverlay",
            action: "putSource",
            params: {
              ...body
            }
          })
        }

        // Update main view
        let initialSource = this.sourceList.find(element => {
          return element.id === this.editSource
        })
        let index = this.sourceList.indexOf(initialSource)
        this.$set(this.sourceList, index, source)
        this.$emit('fetchSources')
        this.cleanData()

        this.notify({
          time: 10000,
          title: this.$t('dash.notifications.success_title'),
          text: this.$t('dash.notifications.source_updated'),
          color: 'primary',
          id: 'norepeat'
        })
      })
    },

    cleanData() {
      this.form = {
        name: null,
        url: null,
        analytics: null,
        logo: null,
        topic: null,
        category: null,
        evergreen: true,
        type: 'rss',
        custom_field: null
      }    
      this.manualName = false
      this.addDefaultSourceName(this.form.type)
      this.searchType = 'search'
      this.$validator.reset();
      this.$emit('close-source-form')
    },
    cancel() {
      this.cleanData()
    }
  }
}
</script>